import { motion } from 'framer-motion';
import { Section } from '@components/ui/Section.jsx';
import { PARTICIPANTS } from '@/data/homeContent.js';
import { Check } from 'lucide-react';
import { OptimizedImage } from '@components/ui/OptimizedImage.jsx';

export function WhoCanParticipate() {
  return (
    <Section className="border-t border-ink-200/50 dark:border-ink-800/50">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <h2 className="h-display text-3xl sm:text-4xl text-ink-900 dark:text-ink-50 capitalize mb-8">
            {PARTICIPANTS.title}
          </h2>
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {PARTICIPANTS.roles.map((role) => (
              <li key={role} className="flex items-start gap-2.5 text-base text-ink-700 dark:text-ink-200 leading-snug">
                <Check size={16} className="text-brand-500 shrink-0 mt-0.5" aria-hidden="true" />
                {role}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="rounded-3xl overflow-hidden shadow-soft ring-1 ring-ink-200/60 dark:ring-ink-700/60"
          >
            <OptimizedImage
              src={PARTICIPANTS.image}
              alt="Conference participation"
              className="w-full h-auto object-cover aspect-[4/3]"
              deferUntilVisible
            />
          </motion.div>
        </div>
      </div>
    </Section>
  );
}
